<div class="flexbox-column gap-0 h-100 overflow-hidden" (click)="$event.stopPropagation()">
    <div class="flexbox-row justify-content-between p-2">
        <h4>Sort</h4>
        <button mat-button class="button-text" (click)="closeMenu.emit('close')">
            <i class="material-icons clear-icon">close</i>
        </button>
    </div>

    <div class="flexbox-row px-2 mb-2 justify-content-between">
        <mat-radio-group class="flexbox-row" aria-label="Select an option" [formControl]="selectedSort">
            <mat-radio-button class="radio-btn" [value]="s"
                *ngFor="let s of sortArray"><span>{{s.name}}</span></mat-radio-button>
        </mat-radio-group>
        <div class="button-group" *ngIf="selectedSort.value.isManual">
            <button mat-button class="button-text" [disabled]="isUpArrowDisabled() || manualSelectedRow() === -1"
                (click)="swapPositions('UP')">
                <i class="fa-regular fa-arrow-up"></i>
            </button>
            <button mat-button class="button-text" [disabled]="isDownArrowDisabled() || manualSelectedRow() === -1"
                (click)="swapPositions('DOWN')">
                <i class="fa-regular fa-arrow-down"></i>
            </button>
        </div>
    </div>
    <div class="w-100 flex-table fixed-header flex-1 overflow-auto"
        [ngClass]="{'manualclass': selectedSort.value.isManual,'autoclass': !selectedSort.value.isManual}">
        <div class="flex-table-header">
            <div class="ft-row">
                <p class="ft-header-cell cell-check" *ngIf="selectedSort.value.isManual"></p>
                <p class="ft-header-cell flex-nowrap cell-group-name">
                    <span>Sub Group</span>
                    <button mat-button class="button-text" *ngIf="!selectedSort.value.isManual"
                        (click)="toggleSort('group')">
                        <img alt="group"
                        [ngClass]="!groupisASC() ? 'fa-regular fa-arrow-up' : 'fa-regular fa-arrow-down'" />
                    </button>
                </p>
                <p class="ft-header-cell text-end flex-nowrap cell-sort-value">
                    <span>Amount</span>
                    <button mat-button class="button-text" *ngIf="!selectedSort.value.isManual"
                        (click)="toggleSort('amount')">
                        <img alt="amount"
                        [ngClass]="!amountisASC() ? 'fa-regular fa-arrow-up' : 'fa-regular fa-arrow-down'" />
                    </button>
                </p>
            </div>
        </div>
        <div class="flex-table-body">
            <div class="ft-row" *ngFor="let row of sortData;let i=index;">
                <p class="ft-cell cell-check" *ngIf="selectedSort.value.isManual">
                    <mat-checkbox [checked]="row?.isChecked" (change)="updatePosition($event.checked,i)"
                        [disabled]="manualSelectedRow() === -1 ? false : !(manualSelectedRow() === i)"></mat-checkbox>
                </p>
                <p class="ft-cell cell-group-name" title="{{row?.rowName}}">
                    <span class="text-ellipse">{{row?.rowName}}</span>
                </p>
                <p class="ft-cell text-end cell-sort-value"
                    title="{{row?.formattedCurrYear }}">
                    <span class="text-ellipse">{{row?.formattedCurrYear }}</span>
                </p>
            </div>
        </div>
    </div>

    <div class="button-group p-2 border-top w-100">
        <button mat-button mat-flat-button color="primary" class="button-medium flex-1" (click)="closeMenu.emit(sortData)">Apply</button>
    </div>
</div>
